import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { chapterKeys } from "./keys";
import {
  createChapter,
  deleteChapter,
  getAllChapters,
  updateChapter,
  getChapterStats,
  getAllChaptersStats,
  updateTargetConfig,
} from "./api";
import { toast } from "sonner";

export const useChapters = () => {
  return useQuery({
    queryKey: chapterKeys.list(),
    queryFn: getAllChapters,
  });
};

export const useChapterStats = () => {
  return useQuery({
    queryKey: chapterKeys.stats(),
    queryFn: getChapterStats,
  });
};

export const useAllChaptersStats = (options = {}) => {
  return useQuery({
    queryKey: chapterKeys.allStats(),
    queryFn: getAllChaptersStats,
    enabled: false, // Only fetch on demand
    ...options,
  });
};

export const useCreateChapter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createChapter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chapterKeys.list() });
      toast.success("Chapter created successfully");
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Failed to create chapter");
    },
  });
};

export const useUpdateChapter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateChapter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chapterKeys.list() });
      toast.success("Chapter updated successfully");
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Failed to update chapter");
    },
  });
};

export const useDeleteChapter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteChapter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chapterKeys.list() });
      toast.success("Chapter deleted successfully");
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Failed to delete chapter");
    },
  });
};

export const useUpdateTargetConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTargetConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chapterKeys.list() });
      queryClient.invalidateQueries({ queryKey: chapterKeys.stats() });
      toast.success("Target config updated successfully");
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Failed to update target config",
      );
    },
  });
};
